import { Groupthirdline, bluethirdybackgroundImage, buttonfactions, pointOne, pointOneSelected, pointTwo, pointtwoSelected } from "../../images/general";
import React, { useEffect, useState } from "react";
import StoryTabOne from "./StoryTabOne";
import StoryTabTwo from "./StoryTabTwo";
import Story from "./Story";
import { Parallax } from "react-scroll-parallax";


const StorySection = ({storySectionRef, showVideo} : {storySectionRef : any, showVideo: () => void}) => {
  const [activeTab, setActiveTab] = useState(1);

  // //to change tabs every two seconds
  // useEffect(() => {
  //   const intervalId = setInterval(() => {  //assign interval to a variable to clear it.
  //     setActiveTab((prev) => prev === 1 ? 2 : 1);
  //   }, 2000)
  
  //   return () => clearInterval(intervalId); //This is important
   
  // }, [useState])

  const handleTabClick = (tabNumber: any) => {
    setActiveTab(tabNumber);
  };
  return (
    <>
      <section
        className="w-full bg-no-repeat bg-cover bg-center h-full py-1"
        style={{ backgroundImage: `url(${bluethirdybackgroundImage})` }}
      >
                          <img
            src={buttonfactions}
            className="-mt-20 sm:-mt-32 left-0 right-0 sm:bottom-[-145px] -bottom-[70px] mx-auto sm:w-max w-[348px]"
          />
        <div className=" pt-8 sm:pt-16 container mx-auto">
          <img src={Groupthirdline} className="mx-auto sm:w-max w-[327px]" />
        </div>
        <Parallax  scale={[1, 0.75]} easing="easeInQuad">
        <div className="container max-w-7xl mx-auto px-4 sm:flex gap-16"         
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-easing="ease" ref={storySectionRef}>
          <div className="flex sm:flex-col sm:justify-normal justify-center items-center gap-12 sm:mt-0 mt-4">
            <div
              className={`cursor-pointer flex flex-col ${activeTab === 1 ? "" : "animate-heartbeat-effect"}`}
              onClick={() => handleTabClick(1)}
            >
              <img src={activeTab === 1 ? pointOneSelected : pointOne} className="" />
              <span className={`font-cinzel font-bold text-[18px] text-${activeTab === 1 ? 'white' : '[#9DB3CD]'} text-center`}>Story</span>
            </div>
            <div
              className={`cursor-pointer flex flex-col ${activeTab === 2 ? "" : "animate-heartbeat-effect"}`}  //hover:scale-110 transition duration-500
              onClick={() => handleTabClick(2)}
            >
              <img src={activeTab === 2 ? pointtwoSelected : pointTwo} className=""/>
              <span className={`font-cinzel font-bold text-[18px] text-${activeTab === 2 ? 'white' : '[#9DB3CD]'} text-center`}>Engin</span>
            </div>
          </div>
          <div className="w-full">
            {activeTab === 1 && (
              <StoryTabOne showVideo={showVideo}/>
            )}
            {activeTab === 2 && (
              <StoryTabTwo/>
            )}
          </div>
        </div>
        </Parallax>
      </section>
    </>
  );
};

export default StorySection;
